<template>
  <div>
    <div style="width:100%;float:left;padding-top:2%;">
      <label style="width:60px;font-weight:bold;text-align:right;padding-right:1%;">po #</label>
      <tool-tip-error v-if="!valid"
                      :text=error
                      type="purchaseOrder"/>
      <input v-if="!review"
             v-model="purchaseOrder"
             style="font-size:11pt;line-height:25px;margin:0;padding:0;"
             :class="{ 'invalid-indicator' : !valid }"
             type="text"
             placeholder="po number..."
             size="21"
             max="10"
             autocomplete="off"
             :disabled="review"/>
      <span v-else class="review">{{ purchaseOrder }}</span>
    </div>
  </div>
</template>

<script>
import ToolTipError from '@/components/tooltip/TooltipError'

export default {
  name: 'PurchaseOrder',
  props: ['mandatory', 'review'],
  emits: ['purchaseorder', 'isvalid'],
  data: function () {
    return {
      purchaseOrder: '',
      valid: false,
      error: '',
    }
  },
  components: {
    ToolTipError,
  },
  watch: {
    purchaseOrder: function (text) {
      this.valid = (this.mandatory && (text.length > 0 && text.length <= 10)) ||
          (!this.mandatory && (text.trim() === '' || (text.length >= 0 && text.length <= 10)))

      if (this.valid) this.$emit('purchaseorder', this.purchaseOrder)
      this.$emit('isvalid', this.valid)
      if (this.mandatory && text.trim() === '') this.error = 'required'
      if (text.trim() !== '' && text.length > 10) this.error = 'max 10 char'
    },
  },
  mounted() {
    this.valid = ((this.mandatory && this.purchaseOrder.trim() !== '') || !this.mandatory)

    if (!this.valid) this.error = 'required'

    this.$emit('isvalid', this.valid)
  },
}
</script>